module.exports = __webpack_public_path__ + "static/media/bg.580f047e.mp4";